export const setProcedure = (procedure) => ({
    type: "SET_PROCEDURE",
    procedure,
  });